import { deserialize, Field, Model } from 'serialize-ts';
import { EnergyEfficiencyRange } from './energy-efficiency-range.model';
import { EnergyEfficiencyLabel } from '~shared/modules/product-card/models/energy-efficiency-label.enum';
import { EnergyEfficiencyVersion } from '~shared/modules/product-card/models/energy-efficiency-version.enum';
import { EnergyEfficiencyColorMap } from '~shared/modules/product-card/constants/energy-efficiency-color-map.constants';
import { Brand } from '~shared/models/product-card/brand.model';
import { EnergyConfig } from '~shared/modules/product-card/models/energy-config.model';

@Model()
export class Attributes {
  @Field()
  energyEfficiencyImage: string;

  @Field()
  energyEfficiencyClass: EnergyEfficiencyLabel;

  @Field()
  energyEfficiencyRange: EnergyEfficiencyRange;

  @Field()
  energyEfficiencyVersion: EnergyEfficiencyVersion;

  @Field()
  energyEfficiencyColor: string;

  @Field()
  energy_config: EnergyConfig;

  @Field()
  brand: Brand;

  @Field()
  series: string;

  @Field()
  mpq?: number;

  @Field()
  productDataSheet?: string;

  public static map(response: any): Attributes {
    const attributes = deserialize(response, Attributes);
    attributes.energyEfficiencyImage = response.energyLabel || null;
    attributes.energyEfficiencyVersion = response.energyEfficiencyColorMap
      ? JSON.parse(response.energyEfficiencyColorMap)?.version
      : EnergyEfficiencyVersion.OLD_VERSION;
    const EEC_COLOR = response.energyEfficiencyColorMap
      ? JSON.parse(response.energyEfficiencyColorMap)[response.energyEfficiencyClass]
      : null;
    attributes.energyEfficiencyColor = EEC_COLOR ? `#${EEC_COLOR}` : EnergyEfficiencyColorMap.generic;

    return attributes;
  }
}
